import React from 'react';
import Image from "../../Media/Rewards.webp"
import Table from "../../Media/RewardsTable.webp"
import "./Rewards.css";

const Rewards = () =>{
    return (
        <div className = "rewards">
            <img className = "noSelect" src = {Image} alt="" />
            <div>
                <h2>Ödüller</h2>
                <img className = "noSelect" src = {Table} alt="" />
            </div>
        </div>
    )
}

export default Rewards;